export const GIFT_CARD_TYPE = {
  DIGITAL: 1,
  PHYSICAL: 2,
}

export const CART_ORDER_TYPES = {
  2: GIFT_CARD_TYPE.DIGITAL,
  3: GIFT_CARD_TYPE.PHYSICAL,
}

export const PRODUCT_FAMILY = {
  1: GIFT_CARD_TYPE.DIGITAL,
  2: GIFT_CARD_TYPE.PHYSICAL,
}

const DIGITAL_IMAGE = 'images/digital-products.png'
const PHYSICAL_IMAGE = 'images/physical-products.png'

function checkGiftCard({ orderLineItemOrderType, productFamily }) {
  if (CART_ORDER_TYPES.hasOwnProperty(orderLineItemOrderType)) {
    return {
      isGiftCard: true,
      type: CART_ORDER_TYPES[orderLineItemOrderType],
    }
  }

  if (PRODUCT_FAMILY.hasOwnProperty(productFamily)) {
    return {
      isGiftCard: true,
      type: PRODUCT_FAMILY[productFamily],
    }
  }

  return { isGiftCard: false }
}

export function resolveProductRoute(product = {}) {
  const {
    seoName,
    giftCardID = '',
    orderLineItemOrderType,
    productFamily,
  } = product

  const result = checkGiftCard({
    orderLineItemOrderType,
    productFamily,
  })

  if (result.isGiftCard) {
    return {
      name: 'GiftCardDetail',
      params: {
        giftCardId: giftCardID || seoName,
      },
      query: {
        type: result.type,
      },
    }
  }

  return {
    name: 'Detail',
    params: { seoName },
  }
}

export function resolveProductImage(product = {}) {
  const { productFamily, orderLineItemOrderType, images, image, profileImage } =
    product

  const { isGiftCard, type } = checkGiftCard({
    orderLineItemOrderType,
    productFamily,
  })

  if (isGiftCard) {
    return type === GIFT_CARD_TYPE.DIGITAL ? DIGITAL_IMAGE : PHYSICAL_IMAGE
  }

  if (profileImage) return profileImage
  if (image) return image
  if (images?.length) return images[0].imageUrl

  return ''
}
